import { cn } from '@/lib/utils';

export function BrandMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 32 32" className={cn('size-8 shrink-0', className)} aria-hidden>
      <rect width="32" height="32" rx="10" fill="#0f5132" />
      <path d="M16 6l8 6-8 14-8-14z" fill="#fff" opacity=".95" />
      <path d="M8 12h16l-8 14z" fill="#a7e3c3" />
    </svg>
  );
}

export function Brand({ light, subtitle = 'Enterprise Suite' }: { light?: boolean; subtitle?: string }) {
  return (
    <div className="flex items-center gap-2.5">
      <BrandMark />
      <div className="leading-tight">
        <p className={cn('text-[16px] font-extrabold tracking-tight', light ? 'text-white' : 'text-fg')}>Ruby Foam</p>
        <p className={cn('text-[11px]', light ? 'text-emerald-200' : 'text-fg-subtle')}>{subtitle}</p>
      </div>
    </div>
  );
}
